import angular from 'angular';

(function() {
    'use strict';

    // Component DEF
    var kissMsgFileUpload = {
        controller: 'MsgFileUploadCtrl as vm',
        templateUrl: require('./msg-file-upload.html'),
        bindings: {
            nomFichier: '<'
        }
    };

    // Add to the App
    angular.module('app.principal').component('kissMsgFileUpload', kissMsgFileUpload);
})();
